import React from "react";
import { Link } from "react-router-dom";
import useScrollAnimation from "../../hooks/useScrollAnimation";
export default function CustomerSupport() {
    useScrollAnimation();
    return (
        <section className="hv-120 customer-support py-[40px] my-[40px]">
            <div className="container h-full flex flex-col justify-center gap-[15px]">
                <div className="flex flex-col gap-[40px]">
                    <div className="flex flex-col gap-[15px]">
                        <div className="js-scroll fade-btm capitalize text-white text-[30px] font-bold">Book Your Move with Ease Safe, Reliable, and stress-Free!</div>
                        <div className="flex flex-col gap-[25px]">
                            <p className="w-100 js-scroll fade-btm w-[57%] text-white">
                                At M Power Moving Services, we're here during
                                to ensure a smooth and stress-free moving experience.
                                Whether you're scheduling a move, seeking information,
                                or need assistance, our dedicated team is ready to help
                            </p>
                            <div className="flex flex-col gap-[5px]">
                                <div className="js-scroll fade-btm font-bold text-[24px] text-white">Let us take care of the details while you focus on your new beginning!</div>
                            </div>
                        </div>
                    </div>
                    <div className="js-scroll fade-btm w-fit text-white">
                        <span className="text-[25px] ">Customer Support :</span>
                        <ul>
                            <li className="capitalize font-[11px]">Monday to Friday 10 AM to 5 PM</li>
                            <li className="capitalize font-[11px]">Sunday off</li>
                            <li className="capitalize font-[11px]">Saturday 11 AM to 3 PM</li>
                        </ul>
                    </div>
                </div>
                <div className="flex items-center gap-[7px]">
                    <Link className="js-scroll fade-btm bg-[#ffffff] font-bold text-[#294a6a] py-[6px] px-[20px] rounded-[4px]" to={"/quote"}>Get A Free Quote</Link>
                    <Link className="js-scroll fade-btm bg-[#ffffff] font-bold text-[#294a6a] py-[6px] px-[20px] rounded-[4px]" to={"/contact"}>Contact us now</Link>
                </div>
            </div>
        </section>
    );
}